<template>
	<div class="sign-up">
		<h3>New User</h3>
		<form>
			<!-- <input type="text" v-model="name" name="Name" placeholder="Name"><br><br> -->
			<input type="text" v-model="email" name="Email" placeholder="Email"><br><br>
			<input type="password" v-model="password" name="Password" placeholder="Password"><br>
			<button @click.prevent="signUp">Sign Up</button>
			<p>or go back to <router-link to="/login/">login</router-link>.</p>
		</form>
	</div>
</template>

<script>
	import firebase from '@/config/firebase';

	export default {
		name: 'signUp',
		data(){
			return {
				email: '',
				password: ''
			}
		},
		methods: {
			signUp(){
				firebase.auth().createUserWithEmailAndPassword(this.email, this.password).then(
					(user) => {
						this.$router.replace('/home/');
					},
					(err) => {
						alert('Oops!' + err.message);
					}
				);
			}
		}
	}
</script>

<style lang="scss" scoped>
	.sign-up {
		color: white;
		text-align: center;
	}
</style>